export default {
  ///url: "http://51.75.251.122/cuma/api/"

  //DEV
  /*
  url: "https://apidev.kemtag.fr/cuma/api/",
  link : "https://appdev.kemtag.fr/#/",
  siteGestionnaire : "https://appdev.kemtag.fr/#/",
  siteAdherent : "https://appudev.kemtag.fr/#/",
*/
    //PROD
  
  url: "https://apiprod.kemtag.fr/cuma/api/",
  link : "https://appprod.kemtag.fr/#/",
  siteGestionnaire : "https://appprod.kemtag.fr/#/",
  siteAdherent : "https://appuprod.kemtag.fr/#/",
  
}